import { render, staticRenderFns } from "./Etapa.vue?vue&type=template&id=2aed4738&scoped=true"
import script from "./Etapa.vue?vue&type=script&lang=js"
export * from "./Etapa.vue?vue&type=script&lang=js"
import style0 from "./Etapa.vue?vue&type=style&index=0&id=2aed4738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aed4738",
  null
  
)

export default component.exports